
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, CloudLightning, Activity, Backpack, CalendarX, HeartPulse, Recycle } from 'lucide-react';

const TermsAndConditions: React.FC = () => {
    return (
        <div className="min-h-screen bg-black text-white py-24 px-6">
            <div className="max-w-4xl mx-auto">
                <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-[#00d4ff] transition-colors mb-12 group">
                    <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
                    <span className="text-xs font-bold uppercase tracking-widest">Regresar</span>
                </Link>

                <div className="border-l-4 border-[#00d4ff] pl-8 mb-16">
                    <h1 className="text-6xl md:text-8xl font-title uppercase leading-[0.8] mb-6 tracking-tighter">
                        Términos &<br />Condiciones
                    </h1>
                    <p className="text-gray-400 italic text-lg max-w-xl">
                        Es vital que firmes y aceptes estos puntos antes de salir para evitar malentendidos. Tu seguridad es nuestra prioridad.
                    </p>
                </div>

                <div className="grid gap-12">
                    {/* Seguridad y Clima */}
                    <section className="flex gap-8 group">
                        <div className="flex-shrink-0 w-16 h-16 border border-rock flex items-center justify-center bg-stone/20 group-hover:border-[#00d4ff] transition-colors">
                            <CloudLightning className="w-8 h-8 text-[#00d4ff]" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-title uppercase text-white mb-4 tracking-tight">Seguridad y Clima</h2>
                            <p className="text-gray-400 leading-relaxed font-light">
                                El guía se reserva el derecho de modificar el itinerario o cancelar el cruce de pasos de montaña (como El Peñón) si las condiciones climáticas ponen en riesgo la integridad del grupo. La decisión del guía es final.
                            </p>
                        </div>
                    </section>

                    {/* Condición Física */}
                    <section className="flex gap-8 group">
                        <div className="flex-shrink-0 w-16 h-16 border border-rock flex items-center justify-center bg-stone/20 group-hover:border-[#00d4ff] transition-colors">
                            <Activity className="w-8 h-8 text-[#00d4ff]" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-title uppercase text-white mb-4 tracking-tight">Condición Física</h2>
                            <p className="text-gray-400 leading-relaxed font-light">
                                El cliente declara no tener lesiones preexistentes y contar con una condición física adecuada para caminar 7-8 horas diarias con mochila de carga (12-15 kg).
                            </p>
                        </div>
                    </section>

                    {/* Equipo Obligatorio */}
                    <section className="flex gap-8 group">
                        <div className="flex-shrink-0 w-16 h-16 border border-rock flex items-center justify-center bg-stone/20 group-hover:border-[#00d4ff] transition-colors">
                            <Backpack className="w-8 h-8 text-[#00d4ff]" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-title uppercase text-white mb-4 tracking-tight">Equipo Obligatorio</h2>
                            <p className="text-gray-400 leading-relaxed font-light">
                                Si el cliente no se presenta con el equipo mínimo requerido (zapatos de trekking, ropa impermeable, saco de dormir adecuado), el guía puede denegar su participación sin derecho a reembolso.
                            </p>
                        </div>
                    </section>

                    {/* Política de Cancelación */}
                    <section className="flex gap-8 group">
                        <div className="flex-shrink-0 w-16 h-16 border border-rock flex items-center justify-center bg-stone/20 group-hover:border-[#00d4ff] transition-colors">
                            <CalendarX className="w-8 h-8 text-[#00d4ff]" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-title uppercase text-white mb-4 tracking-tight">Política de Cancelación</h2>
                            <div className="space-y-4">
                                <div className="flex items-center gap-4 bg-stone/10 p-4 border-l-2 border-rock group-hover:border-[#00d4ff] transition-colors">
                                    <span className="text-[#00d4ff] font-bold">15 Días:</span>
                                    <span className="text-gray-400 font-light italic text-sm">Devolución del 80% del valor total.</span>
                                </div>
                                <div className="flex items-center gap-4 bg-stone/10 p-4 border-l-2 border-rock group-hover:border-[#00d4ff] transition-colors">
                                    <span className="text-[#00d4ff] font-bold">Menos de 7 Días:</span>
                                    <span className="text-gray-400 font-light italic text-sm">No hay devolución (por bloqueo de fechas del guía).</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Seguro */}
                    <section className="flex gap-8 group">
                        <div className="flex-shrink-0 w-16 h-16 border border-rock flex items-center justify-center bg-stone/20 group-hover:border-[#00d4ff] transition-colors">
                            <HeartPulse className="w-8 h-8 text-[#00d4ff]" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-title uppercase text-white mb-4 tracking-tight">Seguro de Actividades</h2>
                            <p className="text-gray-400 leading-relaxed font-light">
                                Se recomienda encarecidamente que cada participante cuente con un seguro de accidentes personales que cubra actividades de montaña. La montaña es impredecible y estar protegido es vital.
                            </p>
                        </div>
                    </section>

                    {/* Medio Ambiente */}
                    <section className="flex gap-8 group">
                        <div className="flex-shrink-0 w-16 h-16 border border-rock flex items-center justify-center bg-stone/20 group-hover:border-[#00d4ff] transition-colors">
                            <Recycle className="w-8 h-8 text-[#00d4ff]" />
                        </div>
                        <div>
                            <h2 className="text-2xl font-title uppercase text-white mb-4 tracking-tight">Medio Ambiente</h2>
                            <p className="text-gray-400 leading-relaxed font-light">
                                Se aplica estrictamente la política <span className="text-[#00d4ff] font-bold">"No Deje Rastro"</span>. Todo residuo generado durante la expedición debe volver con nosotros a Coyhaique / Villa Cerro Castillo. Respetar la naturaleza es nuestra primera regla.
                            </p>
                        </div>
                    </section>
                </div>

                <div className="mt-24 pt-12 border-t border-rock">
                    <div className="flex items-center gap-3 text-gray-500 italic text-sm">
                        <ShieldCheck className="w-5 h-5 text-[#00d4ff]" />
                        <span>Al reservar cualquier expedición con Fisura Expeditions, declaras haber leído y aceptado estos términos.</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
